import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { AGENTS_ACCESS_PERMISSIONS } from 'dashboard/constants/permissions.js';
import AgentHome from './Index.vue';

// /settings/agents — rota usa Index.vue direto (sem SettingsWrapper).
// Padrao Studio: page e responsavel por seu layout via <PageLayout>
// + <PageHeader>. Redirect /settings/agents -> /settings/agents/list e
// /settings/agents/list usam o mesmo Index pra preservar links salvos.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      meta: {
        featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
        permissions: ['administrator', AGENTS_ACCESS_PERMISSIONS],
      },
      redirect: to => {
        return { name: 'agent_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/agents/list'),
      name: 'agent_list',
      component: AgentHome,
      meta: {
        featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
        permissions: ['administrator', AGENTS_ACCESS_PERMISSIONS],
      },
    },
  ],
};
